import { TfiArrowTopRight, TfiArrowDown } from "react-icons/tfi";
import { FormattedMessage } from "react-intl";

type Props = {
  percent: number;
};

const StatisticsPercentOverview = ({ percent }: Props) => {
  // Determine the class based on the percent value
  const getColorClass = (percent: any) => {
    if (+percent < 0) {
      return "text-color-danger";
    } else if (percent > 0) {
      return "text-color-success";
    } else {
      return "text-color-gray";
    }
  };

  return (
    <p className="flex items-center w-full">
      {+percent === 0 ? null : +percent < 0 ? (
        <TfiArrowDown className="text-color-danger" />
      ) : (
        <TfiArrowTopRight className="text-color-success" />
      )}

      <span className={`${getColorClass(percent)} mx-1`}>{percent}</span>
      <span>
        <FormattedMessage id="increase_from_last_month" />
      </span>
    </p>
  );
};

export default StatisticsPercentOverview;
